export const selectProducts = store => store.productsStore.products;
export const selectProductsDetails = store => store.productsStore.currentProduct;